import React from 'react'

export const RATING_COLUMN_HINTS = {
  expected:
    'Turnirdən əvvəlki reytinqlərə əsasən gözlənilən nəticə (0–1): komandanın digər komandaların neçə faizini qabaqlaması gözlənilirdi.',
  actual:
    'Real nəticə (0–1): komanda digər komandaların neçə faizini qabaqladı. Bərabər nəticə yarım sayılır.',
  k:
    'K — bu turnirdə reytinqin nə qədər dəyişə biləcəyini göstərir. Dəyişmə = K × (Faktiki − Gözlənilən). ' +
    'K turnirin həcmindən (rəqiblərin və sualların sayı) və reytinqin dəqiqliyindən asılıdır: ' +
    'yeni və ya uzun fasilədən qayıdan komandalar üçün K daha böyükdür (maksimum 64).',
  delta: 'Bu turnirdə reytinqin dəyişməsi: K × (Faktiki − Gözlənilən).',
}

type Props = {
  label: string
  hint?: string
  align?: 'left' | 'right'
}

/** Table header cell with an optional hover/focus tooltip explaining the column. */
const RatingColumnHeader: React.FC<Props> = ({ label, hint, align = 'right' }) => (
  <th className={`px-3 py-2 ${align === 'right' ? 'text-right' : 'text-left'}`}>
    {hint ? (
      <span className="relative inline-flex items-center gap-1 group cursor-help" tabIndex={0} aria-label={`${label}: ${hint}`}>
        <span className="underline decoration-dotted underline-offset-4">{label}</span>
        <span className="inline-flex items-center justify-center w-4 h-4 rounded-full bg-slate-200 dark:bg-gray-700 text-[10px] font-bold text-slate-600 dark:text-gray-300">
          ?
        </span>
        <span
          role="tooltip"
          className={`pointer-events-none absolute top-full z-20 mt-2 w-72 rounded-lg bg-slate-900 dark:bg-gray-700 px-3 py-2 text-left text-xs font-normal normal-case leading-relaxed text-white shadow-lg opacity-0 transition-opacity group-hover:opacity-100 group-focus:opacity-100 ${
            align === 'right' ? 'right-0' : 'left-0'
          }`}
        >
          {hint}
        </span>
      </span>
    ) : (
      label
    )}
  </th>
)

export default RatingColumnHeader
